import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { updateMarkupAction, deleteMarkupAction } from 'actions/markupActions'
import { notificationAction } from 'actions/notificationActions'
import { FillPicker, BorderPicker } from '../ColorPicker'
import capitalizeFirstLetter from 'helpers/capitalizeFirstLetter'

const mapStateToProps = ({ map: { markups }, currentEntity: { id } }) => {
  const currentMarkup = markups.find(m => m.id === id)
  return { currentMarkup }
}

const initialState = { showFillPicker: false, showBorderPicker: false }

class EditShape extends React.Component {
  state = { showFillPicker: false, showBorderPicker: false }

  setHexValue = (value, key, close = true) => {
    const { updateMarkupAction, currentMarkup } = this.props
    updateMarkupAction(currentMarkup.id, { [key]: value })
    if (close) this.setState(initialState)
  }

  toggle = key => {
    if (this.state[key]) this.setState(initialState)
    else this.setState({ ...initialState, [key]: true })
  }

  computeBounds = (type, overlay) => {
    if (type === 'rectangle' || type === 'circle') return overlay.getBounds()

    let bounds = new google.maps.LatLngBounds()
    overlay.getPath().getArray().forEach(latLng => bounds.extend(latLng))
    return bounds
  }

  renderBody() {
    const { setHexValue, state: { showFillPicker, showBorderPicker }, props: { currentMarkup: { fillColor, strokeColor }, classes } } = this

    if (showFillPicker) return <FillPicker { ...{ fillColor, setHexValue } } />
    if (showBorderPicker) return <BorderPicker { ...{ strokeColor, setHexValue } } />

    return <div className={classes.filler} />
  }

  render() {
    const { toggle, computeBounds, props: { currentMarkup, updateMarkupAction, deleteMarkupAction, notificationAction, classes } } = this

    if (!currentMarkup) return null

    const { id, type, locked, remove, overlay, fillColor, strokeColor } = currentMarkup

    return (
      <div className={classes.editShape}>
        <div className={classes.header}>
          Edit { capitalizeFirstLetter(type) }
        </div>
        <div className={classes.buttonsContainer}>
          <div
            onClick={_ => {
              if (locked) notificationAction(`Cannot delete locked ${type}`)
              else {
                remove()
                deleteMarkupAction(id)
              }
            }}
            className={classes.deleteButton}
          >
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </div>
          { type !== 'polyline' && type !== 'wall' &&
            <div className={classes.colorButton} onClick={_ => toggle('showFillPicker')} style={{ color: fillColor === '#0000' ? 'white' : fillColor }}>
              <FontAwesomeIcon icon='fill' className={classes.colorIcon} />
            </div>
          }
          <div className={classes.colorButton} onClick={_ => toggle('showBorderPicker')} style={{ color: strokeColor === '#0000' ? 'white' : strokeColor }}>
            <FontAwesomeIcon icon={['far', 'square']} className={classes.colorIcon} />
          </div>
          <div onClick={_ => overlay.map.fitBounds(computeBounds(type, overlay))}>
            <FontAwesomeIcon icon='map-marker-alt' />
          </div>
          <div onClick={_ => updateMarkupAction(id, { locked: !locked })}>
            <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} />
          </div>
        </div>
        { this.renderBody() }
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateMarkupAction, deleteMarkupAction, notificationAction })(injectSheet(style)(EditShape))



// WEBPACK FOOTER //
// ./src/components/BottomBar/EditShape/index.js